module.exports = __webpack_public_path__ + "media/team_photos/Ahmet-Akin-photo-c2d053eb.webp";